import script from "./Links.vue?vue&type=script&setup=true&lang=js"
export * from "./Links.vue?vue&type=script&setup=true&lang=js"

import "./Links.vue?vue&type=style&index=0&id=66a97068&lang=css"

const __exports__ = script;

export default __exports__